export const messages = {
  en: {
    feeSummary: {
      title: 'Fee Summary',
      day: 'Day',
      month: 'Month',
      year: 'Year',
      time: 'Time',
      feeItemId: 'Fee Item ID',
      feeItemName: 'Fee Item Name',
      receivableAmount: 'Receivable Amount',
      receivedAmount: 'Received Amount',
      yuan: 'yuan',
      fetchError: 'Failed to fetch fee summary data',
      page: {
        title: 'Fee Summary',
        subtitle: 'Review receivable and received amounts by fee item',
        empty: 'No fee summary records found',
        loadFailed: 'Failed to load fee summary data, please retry',
        tip: 'Switch between daily, monthly and yearly aggregation to compare collection progress.'
      }
    }
  },
  zh: {
    feeSummary: {
      title: '缴费汇总表',
      day: '日',
      month: '月',
      year: '年',
      time: '时间',
      feeItemId: '费用项ID',
      feeItemName: '费用项名称',
      receivableAmount: '应收金额',
      receivedAmount: '实收金额',
      yuan: '元',
      fetchError: '获取缴费汇总数据失败',
      page: {
        title: '缴费汇总表',
        subtitle: '按收费项目查看应收与实收金额',
        empty: '暂无缴费汇总数据',
        loadFailed: '缴费汇总数据加载失败，请重试',
        tip: '可切换日、月、年三个汇总维度对比收费进度。'
      }
    }
  }
}